var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2603 3.60315L5.05034 12.2931C4.74034 12.6231 4.44034 13.2731 4.38034 13.7231L4.01034 16.9631C3.88034 18.1331 4.72034 18.9331 5.88034 18.7331L9.10034 18.1831C9.55034 18.1031 10.1803 17.7731 10.4903 17.4331L18.7003 8.74315C20.1203 7.24315 20.7603 5.53315 18.5503 3.44315C16.3503 1.37315 14.6803 2.10315 13.2603 3.60315Z",
    stroke: "#5466F9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8896 5.04688C12.3196 7.80687 14.5596 9.91687 17.3396 10.1969",
    stroke: "#5466F9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22H21",
    stroke: "#5466F9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEdit);
export default __webpack_public_path__ + "static/media/ActiveEdit.b7477c95.svg";
export { ForwardRef as ReactComponent };